var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { palette } from '@/theme/palette';
import { Button } from '@mui/material';
import { AnimatedCircles } from 'hx-ui';
export function AnimatedButton(_a) {
    var children = _a.children, onClick = _a.onClick, duration = _a.duration;
    function colorTransform(index) {
        var colors = [
            palette.common.black,
            palette.common.beige,
            palette.common.banner,
        ];
        return colors[index];
    }
    function opacityTransform(index) {
        return 0.7 - 0.2 * index;
    }
    // at start hearing test
    return (_jsx(AnimatedCircles, __assign({ duration: duration, color: palette.secondary.main, colorTransform: colorTransform, opacityTransform: opacityTransform }, { children: _jsx(Button, __assign({ onClick: onClick, className: 'rounded-full h-28 w-28 min-w-full' }, { children: children })) })));
}
